import { useEffect } from 'react';
import { useMyProfile } from '../lib/profile/useMyProfile';
import { applyLocale, currentLocale } from './applyLocale';

/** After sign-in, the language saved on the account wins over this device's guess. */
export function useProfileLocaleSync(): void {
  const savedLocale = useMyProfile().data?.locale ?? null;

  useEffect(() => {
    if (savedLocale && savedLocale !== currentLocale()) void applyLocale(savedLocale);
  }, [savedLocale]);
}
